import { signOut } from 'firebase/auth';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../features/counter/userSlice';
import { auth } from '../firebase';
import Navbar from '../Navbar';
import "./ProfileScreen.css"

function ProfileScreen() {
    const user = useSelector(selectUser);
  return (
    <div  className='profileScreen'>
      <Navbar/>
      <div className="profileScreen__body">
        <h1>Edit Profile</h1>
        <div className="profileScreen__info">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-W6yn_THZi4dt3WCZKmAiTQCKAl1pZ2RvIw&usqp=CAU" alt="" />
       
        <div className="profileScreen__details">
            <h2>{user.email}</h2>
            <div className="profileScreen__plans">
                <h3>Plans</h3>
                <p></p>
                <button onClick={() => signOut(auth)} className='profileScreen__signout'>Sign Out</button>
            </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileScreen
